import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: flex-end;
  gap: ${props => props.theme.whiteLabel.spacing.sp4};

  img {
    height: 16px;
  }

  p {
    margin: 0;
    font-weight: 600;
    font-family: ${props => props.theme.texts.titleS.fontFamily};
    font-size: ${props => props.theme.texts.titleS.fontSize};
    line-height: ${props => props.theme.texts.titleS.lineHeight};
    color: ${props => props.theme.colors.black};
  }
`
